import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { DocumentsTableComponent } from './documents-table.component';
import { RnplColDirective } from './rnpl-col.directive';
import { RnplCommonModule } from 'common/src/modules/rnpl-common';
import { MenuPanelModule } from '../menu-panel/menu-panel.module';
import { MenuSelectModule } from '../menu-select/menu-select.module';
import { TruncateTooltipModule } from '../../directives/truncate-tooltip/truncate-tooltip.module';
// import { UIComponentsModule } from 'common/src/modules';


@NgModule({
  declarations: [
    DocumentsTableComponent,
    RnplColDirective
  ],
  exports: [
    DocumentsTableComponent,
    RnplColDirective
  ],
  imports: [
    CommonModule,
    // UIComponentsModule,
    TranslateModule,
    RnplCommonModule,
    MenuPanelModule,
    MenuSelectModule,
    TruncateTooltipModule
    // PerfectScrollbarModule
  ]
})
export class DocumentsTableModule { }
